import PropTypes from "prop-types";
import React from "react";
import account from "../../../assets/icons/account.svg";
import arrowDown from "../../../assets/icons/arrow-down.svg";
import arrowLeft from "../../../assets/icons/arrow-left.svg";
import arrowRight from "../../../assets/icons/arrow-right.svg";
import arrowUp from "../../../assets/icons/arrow-up.svg";
import arrowUpDown from "../../../assets/icons/arrow-up-down.svg";
import barcode from "../../../assets/icons/barcode.svg";
import box from "../../../assets/icons/box.svg";
import boxAdd from "../../../assets/icons/box-add.svg";
import boxOpen from "../../../assets/icons/box-open.svg";
import boxQuestion from "../../../assets/icons/box-question.svg";
import calendarWarning from "../../../assets/icons/calendar-warning.svg";
import calender from "../../../assets/icons/calender.svg";
import change from "../../../assets/icons/change.svg";
import chatBubble from "../../../assets/icons/chat-bubble.svg";
import check from "../../../assets/icons/check.svg";
import checkLarge from "../../../assets/icons/check-large.svg";
import checkbox from "../../../assets/icons/checkbox.svg";
import checkboxChecked from "../../../assets/icons/checkbox-checked.svg";
import checkboxHover from "../../../assets/icons/checkbox-hover.svg";
import circleBlue from "../../../assets/icons/circle-blue.svg";
import circleBorder from "../../../assets/icons/circle-border.svg";
import circleChecked from "../../../assets/icons/circle-checked.svg";
import circleGray from "../../../assets/icons/circle-gray.svg";
import circleGreen from "../../../assets/icons/circle-green.svg";
import circleInner from "../../../assets/icons/circle-inner.svg";
import circleQuestion from "../../../assets/icons/circle-question.svg";
import circleRed from "../../../assets/icons/circle-red.svg";
import cog from "../../../assets/icons/cog.svg";
import csvFile from "../../../assets/icons/csv-file.svg";
import down from "../../../assets/icons/down.svg";
import draggable from "../../../assets/icons/draggable.svg";
import error from "../../../assets/icons/error.svg";
import errorTiny from "../../../assets/icons/errorTiny.svg";
import exclamation from "../../../assets/icons/exclamation.svg";
import filter from "../../../assets/icons/filter.svg";
import flammable from "../../../assets/icons/flammable.svg";
import fridge from "../../../assets/icons/fridge.svg";
import healthHazard from "../../../assets/icons/health-hazard.svg";
import itemList from "../../../assets/icons/item-list.svg";
import key from "../../../assets/icons/key.svg";
import left from "../../../assets/icons/left.svg";
import list from "../../../assets/icons/list.svg";
import listInvoice from "../../../assets/icons/list-invoice.svg";
import lock from "../../../assets/icons/lock.svg";
import lockLocked from "../../../assets/icons/lock_locked.svg";
import lockOneLocked from "../../../assets/icons/lock_1_locked.svg";
import lockUnlocked from "../../../assets/icons/lock_unlocked.svg";
import logout from "../../../assets/icons/logout.svg";
import menu from "../../../assets/icons/menu.svg";
import message from "../../../assets/icons/message.svg";
import minus from "../../../assets/icons/minus.svg";
import mobilePhone from "../../../assets/icons/mobile-phone.svg";
import nlogo from "../../../assets/icons/nlogo.svg";
import notification from "../../../assets/icons/notification.svg";
import pen from "../../../assets/icons/pen.svg";
import plus from "../../../assets/icons/plus.svg";
import poisonous from "../../../assets/icons/poisonous.svg";
import print from "../../../assets/icons/print.svg";
import pushPin from "../../../assets/icons/push-pin.svg";
import radiobox from "../../../assets/icons/radiobox.svg";
import radioboxChecked from "../../../assets/icons/radiobox_checked.svg";
import radioboxHover from "../../../assets/icons/radiobox_hover.svg";
import recycle from "../../../assets/icons/recycle.svg";
import right from "../../../assets/icons/right.svg";
import scan from "../../../assets/icons/scan.svg";
import search from "../../../assets/icons/search.svg";
import snowflake from "../../../assets/icons/snowflake.svg";
import starBorder from "../../../assets/icons/star-border.svg";
import starFilled from "../../../assets/icons/star-filled.svg";
import thermostat from "../../../assets/icons/thermostat.svg";
import time from "../../../assets/icons/time.svg";
import trashBin from "../../../assets/icons/trash-bin.svg";
import truck from "../../../assets/icons/truck.svg";
import up from "../../../assets/icons/up.svg";
import upload from "../../../assets/icons/upload.svg";
import viewItem from "../../../assets/icons/view-item.svg";
import viewList from "../../../assets/icons/view-list.svg";
import warning from "../../../assets/icons/warning.svg";
import warningTiny from "../../../assets/icons/warningTiny.svg";
import waterdrop from "../../../assets/icons/waterdrop.svg";
import waterdropNot from "../../../assets/icons/waterdrop-not.svg";
import x from "../../../assets/icons/x.svg";

export const iconTypes = {
    account: account,
    arrowDown: arrowDown,
    arrowLeft: arrowLeft,
    arrowRight: arrowRight,
    arrowUp: arrowUp,
    arrowUpDown: arrowUpDown,
    barcode: barcode,
    box: box,
    boxAdd: boxAdd,
    boxOpen: boxOpen,
    boxQuestion: boxQuestion,
    check: check,
    calender: calender,
    calendarWarning: calendarWarning,
    change: change,
    chatBubble: chatBubble,
    checkbox: checkbox,
    checkboxChecked: checkboxChecked,
    checkboxHover: checkboxHover,
    checkLarge: checkLarge,
    circleBlue: circleBlue,    
    circleBorder: circleBorder,
    circleChecked: circleChecked,
    circleGray: circleGray,
    circleGreen: circleGreen,    
    circleInner: circleInner,
    circleQuestion: circleQuestion,
    circleRed: circleRed,
    cog: cog,
    csvFile: csvFile,
    down: down,
    draggable: draggable,    
    error: error,
    errorTiny: errorTiny,
    exclamation : exclamation,
    filter: filter,
    flammable : flammable,
    fridge: fridge,
    healthHazard : healthHazard,
    itemList: itemList,
    key: key,
    left: left,
    list: list,
    listInvoice: listInvoice,
    lock: lock,
    lockOneLocked: lockOneLocked,
    lockLocked: lockLocked,
    lockUnlocked: lockUnlocked,
    logout: logout,
    menu: menu,
    message: message,
    minus: minus,
    mobilePhone: mobilePhone,
    nlogo: nlogo,
    notification: notification,
    pen: pen,
    plus: plus,
    poisonous : poisonous,
    print: print,
    pushPin: pushPin,
    radiobox: radiobox,
    radioboxChecked: radioboxChecked,
    radioboxHover: radioboxHover,
    recycle: recycle,
    right: right,
    scan: scan,
    search: search,
    snowflake: snowflake,
    starBorder: starBorder,
    starFilled: starFilled,
    thermostat: thermostat,
    time: time,
    trashBin: trashBin,
    truck: truck,
    up: up,
    upload: upload,
    viewItem: viewItem,
    viewList: viewList,
    warning: warning,
    warningTiny: warningTiny,
    waterdrop: waterdrop,
    waterdropNot: waterdropNot,
    x: x,
};

export const iconColor = {
    dark: "%234B587B",
    red: "%23E63332",
    white: "%23ffffff",
};

/**
 * Returnerar Icon node med icon kod inkluderad
 * @param {object} props
 * @returns {node}
 */
function Icon({type, opacity, style, className, color}) {
    if( !type || type.length===0 ){
        throw "<Icon...> failed to receive icon type string";
    }

    let setStyle = style;
    let urlStr = type;

    //replace all color strings with set color
    if( color  ){
        urlStr = urlStr.replace(/stroke=['"]%23[0-9a-f]{3,6}['"]/gi,`stroke='${color}'`);
        urlStr = urlStr.replace(/fill=['"]%23[0-9a-f]{3,6}['"]/gi,`fill='${color}'`);
    }
    if (opacity!==undefined) {
        if (urlStr.includes("opacity")) {
            urlStr = urlStr.replace(/opacity=['"].*?['"]/, `opacity='${opacity}'`);
        } else {
            setStyle = {
                ...setStyle,
                opacity
            };
        }
    }
    //
    return (<img src={urlStr} alt="" style={setStyle} className={`svg-normal ${className}`}/>);
}

Icon.propTypes = {
    //What iconTypes that should be displayed
    type: PropTypes.string.isRequired,
    //custome styling object for img tag
    style: PropTypes.object,
    //scss classname style
    className: PropTypes.string,
    //what color to use, iconColor.dark, iconColor.red or iconColor.white
    color: PropTypes.string,
    //[0,1] 0=invisible 1=visible
    opacity: PropTypes.number
};

Icon.defaultProps = {
    style: undefined,
    color: undefined,
    opacity: undefined
};

export default Icon;